import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HistoryRouter as Router } from 'redux-first-history/rr6';

import { history } from '~redux/store';
import { store } from './lib/redux/store';

import CustomToastContainer from './lib/ToastContainer';
import App from './App';

import '~sass/main.scss';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-datepicker/dist/react-datepicker.css';

const domNode = document.getElementById('root');
const root = createRoot(domNode!); // root element is hardcoded in the public/index.html file so it absolutely exists

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <Router history={history}>
                <CustomToastContainer />

                <App />
            </Router>
        </Provider>
    </React.StrictMode>,
);
